<template>
    <!--新版腰腹围-->
    <div>
        <div class="body-roundness" :class="{ 'no-container-background': !isSupportWebgl.webgl }">
            <div
                class="person-img"
                :class="{ 'person-img-width': modelInfo.bdaStatus !== 1 }"
                v-if="isSupportWebgl.webgl"
            >
                <img class="measure-top" src="@/assets/images/waist/fill@2x.png" />
                <img class="measure-bottom" src="@/assets/images/waist/fill2@2x.png" alt />
                <div class="model-container">
                    <measure-model-mld
                        v-if="dispalyModel"
                        class="measure-model"
                        ref="waistmodel"
                        :tcScanId="tcScanIdCopt"
                        @statusDispaly="OnIsDispaly"
                        :show-girth="true"
                        @modelLoadOver="modelLoadOver"
                    ></measure-model-mld>
                    <!-- 日期选择 -->
                    <div class="data-time">
                        <date-select
                            :type="3"
                            :isCreateTime="isCreateTime"
                            @girthContras="onwaistContrasInfo"
                        ></date-select>
                    </div>
                </div>
            </div>
            <!-- 判断浏览器支持 -->
            <version-tip v-else :tipMsg="isSupportWebgl.tipMsg" :title="isSupportWebgl.title" msgStyle="msg-style">
            </version-tip>

            <template v-if="isSupportWebgl.webgl && dispalyModel">
                <div
                    v-for="(item, index) in roundness"
                    :key="index + 'rr'"
                    :class="{ 'hidden-roundness': modelInfo.bdaStatus !== 1 }"
                >
                    <div class="right-roundness-slide" v-if="item.girth.delta === slideIndex2">
                        <div class="roundness-data" v-if="isDispaly">
                            <p class="girth-value-top" v-if="unit === 'imperial'">
                                {{ toDecimal(item.lastWidth, 1) > 0 ? toDecimal(item.lastWidth, 1) : '-' }}
                            </p>
                            <p class="girth-value-top" v-else>
                                {{ toDecimal(item.lastWidth, 1) > 0 ? toDecimal(item.lastWidth * 2.54, 1) : '-' }}
                            </p>
                            <p style="font-size: 3.467vw">{{ $i18n.locale === 'ar-AR' ?  unit === "imperial" ? "بوصة" : "سم" : unit === "imperial" ? inI18n('in') : "cm" }}</p>
                        </div>
                        <div class="model-right" v-if="isDispaly">
                            <p class="girth-value" v-if="unit === 'imperial'">
                                {{ toDecimal(item.width, 1) > 0 ? toDecimal(item.width, 1) : '-' }}
                            </p>
                            <p class="girth-value" v-else>
                                {{ toDecimal(item.width, 1) > 0 ? toDecimal(item.width * 2.54, 1) : '-' }}
                            </p>
                            <p>{{ $i18n.locale === 'ar-AR' ?  unit === "imperial" ? "بوصة" : "سم" : unit === "imperial" ? inI18n('in') : "cm" }}</p>
                        </div>
                        <div :class="['roundness-data', isDispaly ? '' : 'model-style']" v-else>
                            <p class="girth-value" v-if="unit === 'imperial'">
                                {{ toDecimal(item.width, 1) > 0 ? toDecimal(item.width, 1) : '-' }}
                            </p>
                            <p class="girth-value" v-else>
                                {{ toDecimal(item.width, 1) > 0 ? toDecimal(item.width * 2.54, 1) : '-' }}
                            </p>
                            <p>{{ $i18n.locale === 'ar-AR' ?  unit === "imperial" ? "بوصة" : "سم" : unit === "imperial" ? inI18n('in') : "cm" }}</p>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="isSupportWebgl.webgl">
                <div
                    :key="index + 'dd'"
                    :class="{ 'hidden-roundness': modelInfo.bdaStatus !== 1 }"
                    v-for="(item, index) in waistarr1"
                >
                    <div
                        :class="['right-roundness-slide-2', tcScanIdtu === null ? 'tcScanIdCopt1' : '']"
                        v-if="index === slideIndex"
                    >
                        <p @click="slideTop" class="arrow">
                            <img src="@/assets/images/jiantou2.png" class="top-arrow" />
                        </p>
                        <div class="roundness-data">
                            <p>{{ item.title }}</p>
                        </div>
                        <p @click="slideBottom" class="arrow">
                            <img src="@/assets/images/jiantou.png" class="lower-arrow" />
                        </p>
                    </div>
                </div>
            </template>
        </div>
        <div class="waist-data-item">
            <waist-data-item :name="$t('yao_wei_1')" :title="$t('yao_bu_fen_shu')" :arr="waistroundness" :unit="$t('waist_fen')"></waist-data-item>
            <waist-data-item :title="$t('yao_wei')" :arr="waistarr1" :unit="unit === 'metric' ?'cm' : inI18n('in')"></waist-data-item>
            <waist-data-item :title="$t('yao_wei_jian_ti_ji')" :arr="waistarr2" :unit="unit === 'metric' ?'cm³' : inI18n('in³')"></waist-data-item>
            <waist-data-item :title="$t('yao_tun_bi')" :arr="waistarr3"></waist-data-item>
            <waist-data-item :title="$t('lun_kuo_fen_xi')" :canvas="true" :arr="waistcanvas"></waist-data-item>
            <waist-data-item :name="$t('bei_bu')" :arr="waistarr4" :unit="unit === 'metric' ?'L' :  inI18n('in³')"></waist-data-item>
            <waist-data-item :name="$t('tunbu')" :arr="waistarr5" :unit="unit === 'metric' ?'cm' : inI18n('in')"></waist-data-item>
        </div>
    </div>
</template>

<script>
import { bmwaistContrasInfo, findBmWaistScanTrueHistory } from '@/assets/js/apolloGql.js'
import isSupportWebgl from '@/assets/js/webgl.js'
import { _toDecimal } from '@/assets/js/util.js'
import MeasureModelMld from '@/components/model/MeasureNewMLD'
import VersionTip from '@/components/model/VersionTip.vue'
import DateSelect from '@/components/common/DateSelect'
import { mapState } from 'vuex'
import WaistDataItem from '@/components/common/WaistDataItem.vue'

export default {
    components: {
        MeasureModelMld,
        VersionTip,
        DateSelect,
        WaistDataItem,
    },
    props: {
        isCreateTime: String,
        oldUser: Number
    },
    data() {
        return {
            isSupportWebgl,
            modelInfo: JSON.parse(window.localStorage.getItem('modelInfo')),
            roundness: [
                {
                    title: this.$t('yao_wei_num', 1),
                    key: 'waistGirth1',
                    key1: 'pointList1',
                    girth: {
                        delta: 0,
                        curveName: 'waist_girth',
                    },
                },
                {
                    title: this.$t('yao_wei_num', 2),
                    key: 'waistGirth2',
                    key1: 'pointList2',
                    girth: {
                        delta: 1,
                        curveName: 'waist_girth_2',
                    },
                },
                {
                    title: this.$t('yao_wei_num', 3),
                    key: 'waistGirth3',
                    key1: 'pointList3',
                    girth: {
                        delta: 2,
                        curveName: 'waist_girth_3',
                    },
                },
                {
                    title: this.$t('yao_wei_num', 4),
                    key: 'waistGirth4',
                    key1: 'pointList4',
                    girth: {
                        delta: 3,
                        curveName: 'waist_girth_4',
                    },
                },
                {
                    title: this.$t('yao_wei_num', 5),
                    key: 'waistGirth5',
                    key1: 'pointList5',
                    girth: {
                        delta: 4,
                        curveName: 'waist_girth_5',
                    },
                },
                {
                    title: this.$t('yao_wei_num', 6),
                    key: 'waistGirth6',
                    key1: 'pointList6',
                    girth: {
                        delta: 5,
                        curveName: 'mid_waist_girth',
                    },
                },
                {
                    title: this.$t('yao_wei_num', 7),
                    key: 'waistGirth7',
                    key1: 'pointList7',
                    girth: {
                        delta: 6,
                        curveName: 'waist_girth_7',
                    },
                },
                {
                    title: this.$t('yao_wei_num', 8),
                    key: 'waistGirth8',
                    key1: 'pointList8',
                    girth: {
                        delta: 7,
                        curveName: 'waist_girth_8',
                    },
                },
                {
                    title: this.$t('yao_wei_num', 9),
                    key: 'waistGirth9',
                    key1: 'pointList9',
                    girth: {
                        delta: 8,
                        curveName: 'waist_girth_9',
                    },
                },
                {
                    title: this.$t('yao_wei_num', 10),
                    key: 'waistGirth10',
                    key1: 'pointList10',
                    girth: {
                        delta: 9,
                        curveName: 'waist_girth_10',
                    },
                },
                {
                    title: this.$t('yao_wei_num', 11),
                    key: 'waistGirth11',
                    key1: 'pointList11',
                    girth: {
                        delta: 10,
                        curveName: 'low_waist_girth',
                    },
                },
            ],
            waistroundness: [],
            waistarr1: [],
            waistarr2: [],
            waistarr3: [],
            waistarr4: [],
            waistarr5: [],
            waistarr6: {},
            waistcanvas: [],
            slideIndex: 0,
            slideIndex2: -1,
            createTime: '.',
            historyDate: [], // 历史数据
            scanId: '',
            isDispaly: true,
            dispalyModel: false,
            tcScanIdCopt: '',
            tcScanIdtu: '',
            isOldUser: false,
            unit: window.localStorage.getItem("unit"),
        }
    },
    computed: {
        ...mapState(['historyScanId', 'historyData']),
    },
    mounted() {
        if (this.historyScanId) {
            this.scanId = this.historyScanId
        } else {
            this.scanId = this.modelInfo.scanId
        }
        this.findBmWaistScanTrueHistory()
    },
    methods: {
        OnIsDispaly(data) {
            if (data === 2) {
                this.isDispaly = true
            } else {
                this.isDispaly = false
            }
        },
        // 获取测量对比的数据
        onwaistContrasInfo(tcScanId) {
            console.log(`获取对比数据id${tcScanId}`)
            this.dispalyModel = false
            if (tcScanId != null) {
                window.localStorage.setItem('tcScanId', tcScanId)
                this.tcScanIdCopt = this.historyData.scanId
            } else {
                this.tcScanIdCopt = this.scanId
                window.localStorage.removeItem('tcScanId', tcScanId)
            }
            this.tcScanIdtu = tcScanId
            this.$apollo
                .query({
                    query: bmwaistContrasInfo,
                    variables: {
                        memberId: this.modelInfo.memberId,
                        scanId: this.scanId,
                        tcScanId: tcScanId,
                    },
                    fetchPolicy: 'network-only',
                })
                .then((res) => {
                    this.dispalyModel = true
                    const data2 = res.data.bmwaistContrasInfo.data
                    // this.historyDate = []
                    this.dataProcessing(data2)
                })
        },
        findBmWaistScanTrueHistory() {
            this.$apollo
                .query({
                    query: findBmWaistScanTrueHistory,
                    variables: {
                        memberId: this.modelInfo.memberId,
                        scanTime: window.localStorage.getItem('createTime')
                            ? JSON.parse(window.localStorage.getItem('createTime'))
                            : this.modelInfo.createTime,
                    },
                    fetchPolicy: 'network-only',
                })
                .then((res) => {
                    const data = res.data.findBmWaistScanTrueHistory
                    this.historyDate = []
                    if (data && data.code === 200) {
                        for (let index = 0; index < data.data.length; index++) {
                            for (let aa = 0; aa < data.data[index].data.length; aa++) {
                                this.historyDate.push(data.data[index].data[aa])
                            }
                        }
                    }
                    console.log(this.historyDate, 'this.historyDatewaist')
                    this.$store.commit('setwaistDataArray', this.historyDate)
                })
        },
        slideTop() {
            if (this.slideIndex === 0) {
                this.slideIndex = this.waistarr1.length - 1
            } else {
                this.slideIndex -= 1
            }
            console.log(this.waistarr1[this.slideIndex].girth)
            this.$refs.waistmodel.selectCurve(this.waistarr1[this.slideIndex].girth)
        },
        slideBottom() {
            this.slideIndex += 1
            if (this.slideIndex === this.waistarr1.length) {
                this.slideIndex = 0
            }
            // console.log('slideIndex', this.waistarr1[this.slideIndex].girth)
            this.$refs.waistmodel.selectCurve(this.waistarr1[this.slideIndex].girth)
        },
        setSlideIdx(idx) {
            console.log('setSlideIdx', idx)
            this.slideIndex2 = idx
            this.slideIndex = this.waistarr1.findIndex((item) => item.girth.delta === idx)
           // console.log(this.slideIndex, 'this.slideIndex3')
        },
        toDecimal(num, digit) {
            return _toDecimal(num, digit)
        },
        modelLoadOver() {
            setTimeout(() => {
                //    this.slideTop()
                this.$refs.waistmodel.selectCurve(this.waistarr1[0].girth)
            }, 2000)
        },
        dataProcessing(data) {
            if (!data) return
            const latestBmWaist = data.latestBmWaist // 本次数据
            const contrastBmWaist = data.contrastBmWaist // 上一次数据
            if (contrastBmWaist) {
                this.roundness.forEach((element) => {
                    element.lastWidth = contrastBmWaist[element.key]
                    element.lastPoint = contrastBmWaist[element.key1]
                })
            } else {
                this.roundness.forEach((element) => {
                    element.lastWidth = 0
                    element.lastPoint = ''
                })
            }
            if (latestBmWaist) {
                this.roundness.forEach((element) => {
                    element.width = latestBmWaist[element.key]
                    element.point = latestBmWaist[element.key1]
                    element.difference = element.lastWidth - latestBmWaist[element.key]
                })
            }

            let volumeArr = null
            if (latestBmWaist) {
                    volumeArr = Array.from({ length: 10 }, (_, index) => ({
                        lastvalue: contrastBmWaist ? contrastBmWaist[`waistVolume${index + 1}`] : 0.0,
                        value: latestBmWaist[`waistVolume${index + 1}`],
                    }))
            }
            // 围度取值 [1, 3, 5, 7, 9, 11]
                this.waistarr1 = []
                this.waistcanvas = [];
                [0, 2, 4, 6, 8, 10].forEach((item, index) => {
                    if (this.roundness && item < this.roundness.length) {
                        let name = ''
                        switch (index) {
                            case 0:
                                name = this.$t('gao_yao_xian')
                                break
                            case 1:
                                name = this.$t('gao_yao_zhong_xian')
                                break
                            case 2:
                                name = this.$t('gao_yao_xia_xian')
                                break
                            case 3:
                                name = this.$t('xiao_yao_shang_xian')
                                break
                            case 4:
                                name = this.$t('xiao_yao_zhong_xian')
                                break
                            case 5:
                                name = this.$t('xiao_yao_xian')
                                break
                        }
                        // 选取腰围
                        this.waistarr1.push({
                            title: name, // 注意：这里用 index 而不是 item
                            lastvalue: this.isMetric(this.roundness[item].lastWidth),
                            value: this.isMetric(this.roundness[item].width),
                            key: this.roundness[item].key,
                            girth: this.roundness[item].girth,
                        })
                        // 选取轮廓
                        this.waistcanvas.push({
                            title: name,
                            lastvalue: this.isMetric(this.roundness[item].lastWidth),
                            value: this.isMetric(this.roundness[item].width),
                            lastpoint: this.roundness[item]['lastPoint'],
                            point: this.roundness[item]['point'],
                        })
                    }
                })
                // 体积取值 [ 1+2 , 3+4, 5+6, 7+8, 9+10]
                this.waistarr2 = []
                let index = 0
                for (let i = 0; i < volumeArr.length; i += 2) {
                    index++
                    if (i + 1 < volumeArr.length) {
                        let name = ''
                        switch (index) {
                            case 1:
                                name = this.$t('qv_jian1')
                                break
                            case 2:
                                name = this.$t('qv_jian2')
                                break
                            case 3:
                                name = this.$t('qv_jian_zhong')
                                break
                            case 4:
                                name = this.$t('qv_jian3')
                                break
                            case 5:
                                name = this.$t('qv_jian4')
                                break
                        }
                        this.waistarr2.push({
                            title: name,
                            lastvalue: this.cmlfMetric(volumeArr[i]['lastvalue'] + volumeArr[i + 1]['lastvalue']),
                            value: this.cmlfMetric(volumeArr[i]['value'] + volumeArr[i + 1]['value']),
                            key: `value${index}`,
                        })
                    }
                }
            if (!contrastBmWaist) {
                // ********新用户********
                this.isOldUser = false
                // 腰部
                this.waistroundness = [{ lastvalue: 0.0, value: latestBmWaist.waistScore }]

                // 腰臀比
                this.waistarr3 = [{ lastvalue: '', value: latestBmWaist.waistHipRatio }]
                // 背部体积
                this.waistarr4 = [
                    { title: this.$t('bei_bu_ti_ji'), lastvalue: '', value: (this.unit === 'metric' ? this.cmlfMetric(latestBmWaist.backVolume) / 1000 : this.cmlfMetric(latestBmWaist.backVolume)).toFixed(2) },
                ]
                // 臀部
                this.waistarr5 = [{ title: this.$t('girth.tpl[6].title'), lastvalue: '', value: this.isMetric(latestBmWaist.hipGirth) }]

                this.waistarr6 = { value: latestBmWaist.waistHipRatio, gender: JSON.parse(window.localStorage.getItem('memberInfo')).sex }

            } else {
                // ********老用户********
                this.isOldUser = true
                this.waistroundness = [{ lastvalue: contrastBmWaist.waistScore, value: latestBmWaist.waistScore }]
                // 腰臀比
                this.waistarr3 = [{ lastvalue: contrastBmWaist.waistHipRatio, value: latestBmWaist.waistHipRatio }]
                // 背部体积
                this.waistarr4 = [
                    {
                        title: this.$t('bei_bu_ti_ji'),
                        lastvalue: (this.unit === 'metric' ? this.cmlfMetric(contrastBmWaist.backVolume) / 1000: this.cmlfMetric(contrastBmWaist.backVolume)).toFixed(2),
                        value: (this.unit === 'metric' ? this.cmlfMetric(latestBmWaist.backVolume) / 1000 : this.cmlfMetric(latestBmWaist.backVolume)).toFixed(2),
                    }
                ]
                // 臀部
                this.waistarr5 = [{ title: this.$t('girth.tpl[6].title'), lastvalue: this.isMetric(contrastBmWaist.hipGirth), value: this.isMetric(latestBmWaist.hipGirth) }]

                this.waistarr6 = { value: latestBmWaist.waistHipRatio, gender: JSON.parse(window.localStorage.getItem('memberInfo')).sex }
            }
            console.log('=================')
            console.log(this.waistarr1)
            console.log('=================')
            window.localStorage.setItem('waistarr1', JSON.stringify(this.waistarr1))
        },
        isMetric(num){
            return this.unit === 'metric' ? num * 2.54 : num
        },
        cmlfMetric(num){
            return this.unit === 'metric' ? num * 16.387064 : num
        },
        inI18n(un){
            if (un === 'in'){
                switch(this.$i18n.locale) {
                    case 'es-ES':
                        return 'pulg.';
                    case 'fr-FR':
                        return 'po.';
                    case 'ar-AR':
                        return 'اﻧﺶ';
                    case 'th-TH':
                        return 'นิ้ว';
                    default:
                        return 'in.';
                }
            } else if (un === 'in³'){
                switch(this.$i18n.locale) {
                    case 'es-ES':
                        return 'pulg.³';
                    case 'fr-FR':
                        return 'po.³';
                    case 'ar-AR':
                        return 'بوصة³';
                    case 'th-TH':
                        return 'นิว³';
                    default:
                        return 'in³';
                }
            }
        },
    },
}
</script>

<style lang="less" scoped>
.hidden-roundness {
    // display: none;
}

.body-roundness {
    background-image: url('../../assets/images/waist/Background.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: left bottom;
    padding-top: 36px;
    margin: 12px;
    // display: flex;
    // justify-content: center;
    position: relative;
    height: auto;
    font-family: PingFangSC, PingFang SC;

    // 禁止部分安卓机下图片自动放大
    img {
        pointer-events: none;
    }

    .girth-box {
        // margin-top: 74px
    }

    .model-container {
        position: relative;
    }

    > div {
        // padding-top: 30px;

        .right-roundness-slide {
            background: none;
            position: absolute;
            top: 0px;
            right: 140px;
            // background-color: brown;

            .roundness-data {
                position: relative;
                top: -40px;
                right: 40px;
                background-image: url('../../assets/images/waist/waist1.png');
                background-repeat: no-repeat;
                background-size: 100% 100%;
                width: 69px;
                height: 69px;
                text-align: center;
                padding-top: 25px;
                margin-bottom: 6px;
                display: flex;
                flex-direction: column;

                p {
                    display: block;
                    font-size: 13px;
                    margin-left: 7px;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                    -webkit-background-clip: text;
                    font-family: PingFangSC, PingFang SC;
                    -webkit-text-fill-color: transparent;
                }

                .girth-value-top {
                    display: block;
                    line-height: 15px;
                    font-size: 18px;
                    margin-left: 6px;
                }

                .girth-value {
                    display: block;
                    line-height: 15px;
                    font-size: 18px;
                    margin-right: 7px;
                }
            }

            .model-style {
                position: relative;
                top: 0px;
                right: -90px;
            }

            .model-right {
                position: relative;
                top: -115px;
                left: 42px;
                width: 69px;
                height: 69px;
                background-image: url(../../assets/images/waist/waist2.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
                text-align: center;
                // font-size: 36px;
                padding-top: 25px;

                p {
                    display: block;
                    font-size: 13px;
                    margin-right: 7px;
                    font-family: PingFangSC, PingFang SC;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .girth-value {
                    display: block;
                    line-height: 15px;
                    font-size: 18px;
                    margin-right: 7px;
                }
            }
        }
    }

    > .person-img-width {
        width: 100% !important;
        background-position: center bottom !important;
    }

    > .person-img {
        // display: flex;
        // justify-content: center;
        // min-width: 215px;
        margin-bottom: 15px !important;
        background-repeat: no-repeat;
        background-position: 58px bottom;
        margin: 0 auto;
        min-height: 300px;

        .measure-top {
            position: absolute;
            left: 8px;
            right: 8px;
            top: 8px;
            width: 96%;
        }

        .measure-bottom {
            position: absolute;
            top: 225px;
            left: 8px;
            right: 8px;
            width: 96%;
        }

        .data-time {
            position: absolute;
            bottom: 0px;
            right: 0;
            left: 0px;
            margin: auto 20px;
            height: 52px;
        }
    }

    .measure-model {
        padding-bottom: 30px;
        height: 300px;
    }
}

.right-roundness-slide-2 {
    margin-left: 0;
    margin-top: 30px;
    background: none;
    position: absolute;
    z-index: 1;
    top: 50px;
    right: 138px;
    width: 70px;
    height: 200px;

    .roundness-data {
        color: white;
    }

    .arrow {
        text-align: center;
        padding: 30px 0;

        i {
            width: 8px;
            height: 8px;
            display: inline-block;
            transform-origin: center center;
            border-top: 2px solid #ffffff;
            border-right: 2px solid #ffffff;
        }

        .top-arrow {
        }

        .lower-arrow {
            margin-bottom: 3px;
        }
    }
}

.waist-data-item {
    margin: 20px auto;
    height: auto;
}

.tcScanIdCopt1 {
    right: 250px;
}
</style>
